import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import { Tooltip } from '@ubnt/ui-components/Tooltip';
import { useState, useRef, useMemo, useCallback, useEffect } from 'react';
import '../../../../../../constants/modelCompareData/assets/close.svg.mjs';
import { useModelCompareTranslation } from '../../../../../../constants/modelCompareData/translations/useModelCompareTranslation.mjs';
import { useMenu } from '../../../../../../contexts/MenuContext/context.mjs';
import { imageSrc } from '../../../../../../utils/asset.mjs';
import { HEADER_HEIGHT } from '../../../../../Header/Header.styles.mjs';
import { Reveal } from '../../../../../Reveal/Reveal.mjs';
import '../../../../../StyleableSvgImage/index.mjs';
import { HeaderGridItem, RemoveProductButton, ProductImageWrap, ProductImage, ProductMeta, ProductHeaderTooltipStyles, ProductHeaderTooltipHoverArea, ProductTitleLink, ProductHeaderTooltipLink, PRODUCT_HEADER_TOOLTIP_CLASSNAME, ProductTitle, ProductNote, ProductDescription, BadgeWrapper } from '../../../CompareTable.styles.mjs';
import { getStoreHref } from '../../../helpers/getStoreHref.mjs';
import { Badges } from '../Badges/Badges.mjs';
import { StyleableSvgImage } from '../../../../../StyleableSvgImage/StyleableSvgImage.mjs';
import closeIcon__default from "../../../../../../assets/close3.svg";
"use strict";
const ProductHeader = ({
  product,
  setSelectedProducts,
  index,
  setExternalState,
  selectedProducts,
  linkToStoreTitleClick,
  hasBeenObserved,
  isLessThanOrEqualToFiveProducts,
  hasMultipleProductsSelected,
  isSmallScreen,
  showBadges,
  isStaticProduct
}) => {
  const {
    formatMessage
  } = useModelCompareTranslation();
  const {
    createSiteUrl,
    languageDirection,
    storeId
  } = useMenu();
  const [productTitleWidth, setProductTitleWidth] = useState(void 0);
  const [toolTipIsPositionedTop, setToolTipIsPositionedTop] = useState(true);
  const productTitleRef = useRef(null);
  const productMetaRef = useRef(null);
  const storeHref = useMemo(() => getStoreHref({
    product,
    createSiteUrl,
    storeId
  }), [product, createSiteUrl, storeId]);
  const techspecsHref = useMemo(() => product.techspecsPath && createSiteUrl(product.techspecsPath), [createSiteUrl, product.techspecsPath]);
  const productTitleHref = useMemo(() => linkToStoreTitleClick ? storeHref : techspecsHref, [linkToStoreTitleClick, storeHref, techspecsHref]);
  const removeHandler = useCallback(() => {
    const updatedProducts = selectedProducts && selectedProducts.filter(selectedProduct => selectedProduct.productId !== product.id);
    if (setExternalState && updatedProducts) {
      setExternalState(updatedProducts);
    }
    if (updatedProducts && setSelectedProducts) {
      setSelectedProducts(updatedProducts);
    }
  }, [product.id, selectedProducts, setExternalState, setSelectedProducts]);
  useEffect(() => {
    if (!productTitleRef.current) return;
    setProductTitleWidth(productTitleRef.current.getBoundingClientRect().width);
  }, [productTitleRef]);
  useEffect(() => {
    const scrollHandler = () => {
      const APPROXIMATE_TOOLTIP_HEIGHT = 45;
      if (productMetaRef.current) setToolTipIsPositionedTop(productMetaRef.current.getBoundingClientRect().top > HEADER_HEIGHT + APPROXIMATE_TOOLTIP_HEIGHT);
    };
    document.addEventListener("scroll", scrollHandler);
    return () => {
      document.removeEventListener("scroll", scrollHandler);
    };
  }, []);
  return /* @__PURE__ */jsx(Reveal, {
    index,
    playAnimation: hasBeenObserved,
    children: /* @__PURE__ */jsxs(HeaderGridItem, {
      children: [!isLessThanOrEqualToFiveProducts && hasMultipleProductsSelected && !isStaticProduct && /* @__PURE__ */jsx(RemoveProductButton, {
        type: "button",
        $isSmallScreen: isSmallScreen,
        onClick: removeHandler,
        children: /* @__PURE__ */jsx(StyleableSvgImage, {
          src: closeIcon__default,
          width: 16,
          height: 16
        })
      }), /* @__PURE__ */jsx(ProductImageWrap, {
        height: product.image.height,
        children: /* @__PURE__ */jsx(ProductImage, {
          loading: "lazy",
          decoding: "async",
          src: imageSrc(product.image.src),
          width: product.image.width,
          alt: formatMessage(product.title)
        })
      }), /* @__PURE__ */jsxs(ProductMeta, {
        ref: productMetaRef,
        children: [linkToStoreTitleClick && storeHref || !linkToStoreTitleClick && techspecsHref ? /* @__PURE__ */jsxs(Fragment, {
          children: [/* @__PURE__ */jsx(ProductHeaderTooltipStyles, {}), /* @__PURE__ */jsxs(Tooltip, {
            motif: "light",
            position: toolTipIsPositionedTop ? "top" : "bottom",
            tooltipClassName: PRODUCT_HEADER_TOOLTIP_CLASSNAME,
            portal: true,
            isInteractive: true,
            description: /* @__PURE__ */jsxs(ProductHeaderTooltipLink, {
              href: productTitleHref,
              target: "__blank",
              children: [formatMessage("modelCompare.reviewIn.tooltip"), " Tech Specs"]
            }),
            children: [/* @__PURE__ */jsx(ProductHeaderTooltipHoverArea, {
              $width: productTitleWidth,
              $tooltipIsPositionedTop: toolTipIsPositionedTop
            }), /* @__PURE__ */jsx(ProductTitleLink, {
              ref: productTitleRef,
              children: formatMessage(product.title)
            })]
          }, `tooltip-${product.id}`)]
        }) : /* @__PURE__ */jsx(ProductTitle, {
          children: formatMessage(product.title)
        }), !!product?.productNote && /* @__PURE__ */jsx(ProductNote, {
          children: formatMessage(product.productNote)
        }), product.description ? /* @__PURE__ */jsx(ProductDescription, {
          $maxWidth: product.descriptionMaxWidth,
          $direction: languageDirection,
          children: formatMessage(product.description)
        }) : null, showBadges && /* @__PURE__ */jsx(BadgeWrapper, {
          children: /* @__PURE__ */jsx(Badges, {
            product
          })
        })]
      })]
    })
  });
};
export { ProductHeader };
//# sourceMappingURL=ProductHeader.mjs.map
